import { c as _c } from "react/compiler-runtime";
import { OpenSeaBrandLogo } from "@opensea/ui-kit/icons";
import { ENVIRONMENT } from "@/constants/env";
import { MultiStepHeader } from "./components/MultiStepHeader";
export function OnboardingHeader(t0) {
  const $ = _c(11);
  const {
    steps,
    setStep,
    currentStep,
    onClose,
    className
  } = t0;
  const t1 = currentStep ?? null;
  let t2;
  if ($[0] !== setStep) {
    t2 = <OpenSeaBrandLogo onClick={() => {
      if (ENVIRONMENT !== "development") {
        return;
      }
      setStep?.("intro");
    }} size={30} />;
    $[0] = setStep;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== setStep) {
    t3 = step_1 => setStep?.(step_1);
    $[2] = setStep;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== className || $[5] !== onClose || $[6] !== steps || $[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = <MultiStepHeader className={className} currentStep={t1} hidden={_temp} indicatorHidden={_temp2} left={t2} onClose={onClose} onStepClick={t3} steps={steps} />;
    $[4] = className;
    $[5] = onClose;
    $[6] = steps;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function _temp2(step_0) {
  return step_0 === "intro" || step_0 === "outro";
}
function _temp(step) {
  return step === "film";
}